import { render, staticRenderFns } from "./g-tab.vue?vue&type=template&id=759a49f2&scoped=true"
import script from "./g-tab.vue?vue&type=script&lang=js"
export * from "./g-tab.vue?vue&type=script&lang=js"
import style0 from "./g-tab.vue?vue&type=style&index=0&id=759a49f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759a49f2",
  null
  
)

export default component.exports